import moment from 'moment';
import { FormatMoneyToDisplay } from '../../helper/currency-helper';
import { EarningLossPerMonthModel } from '../../models/dashboard';
import BarChart from '../ui/BarChart';

const EarningLossPerMonthCard = ({
  data,
}: {
  data: EarningLossPerMonthModel[];
}) => {
  const overallEarning = data.reduce((prev, curr) => {
    return prev + curr.earning + curr.loss;
  }, 0);

  const chartData = {
    labels: data.map((d) => moment(d.date).format('MM-DD-YYYY')),
    datasets: [
      // Light blue bars
      {
        label: 'Stack 1',
        data: data.map((d) => d.earning),
        backgroundColor: 'rgb(99, 102, 241)',
        hoverBackgroundColor: 'rgb(79, 70, 241)',
        barPercentage: 0.66,
        categoryPercentage: 0.66,
      },
      // Blue bars
      {
        label: 'Stack 2',
        data: data.map((d) => d.loss),
        backgroundColor: 'rgb(199, 210, 254)',
        hoverBackgroundColor: 'rgb(165, 180, 252)',
        barPercentage: 0.66,
        categoryPercentage: 0.66,
      },
    ],
  };

  return (
    <div className="flex flex-col col-span-full xl:col-span-6 bg-white  shadow-lg rounded-sm border border-slate-200">
      <header className="px-5 py-4 border-b border-sl  ate-100  flex items-center">
        <h2 className="font-semibold text-slate-800 ">
          Earning/Loss per Month
        </h2>
      </header>
      <div className="px-5 py-3">
        <div className="flex items-start">
          <div
            className={`text-3xl font-bold mr-2 ${
              overallEarning >= 0 ? 'text-green-500' : 'text-red-500'
            }`}
          >
            {overallEarning >= 0 ? '+' : '-'}
            {FormatMoneyToDisplay(overallEarning)}
          </div>
          <div className="text-sm font-semibold text-white px-1.5 bg-amber-500 rounded-full">
            -34%
          </div>
        </div>
      </div>
      {/* Chart built with Chart.js 3 */}
      <div className="grow">
        {/* Change the height attribute to adjust the chart height */}
        <BarChart data={chartData} width={595} height={248} />
      </div>
    </div>
  );
};

export default EarningLossPerMonthCard;
